import * as ko from "knockout";
import {IMessageData} from "../../index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import PromiseRequest from "../../req/PromiseRequest";
import {createErrorMessage} from "../../util/misc";
import {global} from '../../appContext';
import {nsFa} from "../fa/fn";
import {nsRoute} from "../../util/route";
import {REQUEST_MESSAGE} from "../../constants/Language";

export let template: string = importp360rolesHtml;
import i = nsFa.i;
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import importp360rolesHtml from './importp360roles.html?raw';

export class viewModel extends ParsedRouteDataDecorator {
    isWaiting: KnockoutObservable<boolean | null> = ko.observable(null);
    isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private reqTest: PromiseRequest = global.getPromiseRequest("importp360roles");
    data!: string;
    isTest!: boolean;

    private onClick(isTest: boolean) {
        this.isTest = isTest;
        if (!this.isTest) {
            global.dialogManager.addConfirm({
                title: `${i('fa-exclamation-triangle')} ((import roles)) [Public 360°]`,
                content: `<p data-bind="t: 'message: import roles public 360'"></p><p data-bind="t: 'do you wish to continue'"></p>`,
                buttons: {
                    cancel: {
                        label: `no, cancel`
                    },
                    confirm: {
                        label: `yes, continue`,
                        cls: 'btn-danger',
                        onClick: this.doRequest.bind(this),
                    },
                }
            });
        } else {
            this.doRequest();
        }
    }

    private doRequest() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.isWaiting(true);
        this.reqTest
            .request({id: global.getRouteId(), test: this.isTest}, false, {timeout: 30 * 60 * 1000})
            .then((data: any[]) => {
                this.data = data[0];
                this.messageData(null);
                this.isWaiting(false);
                this.isReady(true);
                if (!this.isTest) {
                    global.snackbarData({message: `import completed`});
                }
            })
            .catch((reason: string) => {
                this.isWaiting(false);
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    override dispose() {
        this.kosub.unsuscribeAll();
        this.reqTest.abort();
    }

}
